import axios from 'axios';
import gsap from 'gsap';

function toggleFilter(){
    const buttons = document.querySelectorAll('.pr-filters ul li button')
    if (buttons.length === 0 || buttons === undefined) return
    
    
    const prPosts = document.querySelector('.pr-listings .pr-posts')
    const prListings = document.querySelector('.pr-listings')
    const loadMore = document.querySelector('.pr-listing .load-more')


    window.addEventListener('load', () => {
        document.querySelector('.loading').style.display = "none"
        loadListing(prPosts.children[0].children)
    })

    for (const button of buttons) {
        button.addEventListener('click', (e) => {
            const params = new URLSearchParams();
            const filterId = e.target.dataset.id;
            if (document.querySelector('.the-latest')) {
                params.append('action', 'filter_latest')
            } else {
                params.append('action', 'filter_posts')
            }
            params.append('filter', filterId)

            document.querySelectorAll('.pr-filters ul li button').forEach(button => button.setAttribute('selected', false))
            e.target.setAttribute('selected', true)
            prPosts.innerHTML = ''
            loadMore.style.display = 'none'
            document.querySelector('.loading').style.display = "block"

            axios.post('/wp-admin/admin-ajax.php', params)
            .then(resp => {
                const newListings = document.createElement('div')
                newListings.classList.add('pr-page')
                newListings.insertAdjacentHTML("beforeend", resp.data.data.html)
                prPosts.appendChild(newListings)

                // Get the base URL without the path
                const baseUrl = window.location.protocol + '//' + window.location.host + '/' + prListings.dataset.path;
                if (e.target.dataset.slug !== 'all') {
                    const newUrl = window.history.pushState('', '', baseUrl + '/tag/' + e.target.dataset.slug);
                    window.history.pushState('', '', newUrl);
                } else {
                    window.history.pushState('', '', baseUrl);
                }

                prPosts.dataset.page = 1
                prPosts.dataset.max = resp.data.data.max

                if (newListings.children.length < 20) {
                    loadMore.style.display = 'none'
                  } else {
                    loadMore.style.display = 'block'
                  }
                  document.querySelector('.loading').style.display = "none"
                loadListing(newListings.children)
            })
        })
    }
}

function loadMore() {
    const loadMoreBtn = document.querySelector('.pr-listing .load-more')
    const prPosts = document.querySelector('.pr-listings .pr-posts')
    const prListings = document.querySelector('.pr-listings')


    if (!loadMoreBtn) return

    loadMoreBtn.addEventListener('click', () => {
        const params = new URLSearchParams();
        let currentPage = prListings.dataset.page;
        let maxPages = prListings.dataset.max;

        if (document.querySelector('.the-latest')) {
            params.append('action', 'latest_load_more')
        } else {
            params.append('action', 'filter_posts')
        }
        params.append('current_page', currentPage)
        params.append('max_page', maxPages)

        document.querySelector('.loading-more').style.display = "flex"
        loadMoreBtn.style.display = 'none'

        axios.post('/wp-admin/admin-ajax.php', params)
        .then(resp => {
            const newListings = document.createElement('div')
            newListings.classList.add('pr-page')
            newListings.insertAdjacentHTML("beforeend", resp.data.data.html)
            prPosts.appendChild(newListings)
  
            prListings.dataset.page++;

            if (prListings.dataset.page == prListings.dataset.max) {
                loadMoreBtn.style.display = 'none'
              } else {
                loadMoreBtn.style.display = 'block'
              }

            document.querySelector('.loading-more').style.display = "none"
            loadListing(newListings.querySelectorAll('a'))
        })
    })

}

function handleMobileFilters() {
    const mobileFilterOpen = document.querySelector('.pr-filter-module-open')
    const filterButtons = document.querySelectorAll('.pr-filters button')
    const filterSection = document.querySelector('.pr-filters')

    mobileFilterOpen?.addEventListener('click', () => {
        filterSection.classList.remove('pr-filters--closed')
        document.querySelector('html').style.overflow = 'hidden'
    })
    filterButtons?.forEach(button => button.addEventListener('click', () => {
        if (filterSection.classList.contains('pr-filters--closed')) return
        document.querySelector('html').style.overflow = null
        filterSection.classList.add('pr-filters--closed')
    }))
}

function loadListing(prPage) {
    gsap.fromTo(prPage, { 
        y: 60,
    }, 
    { 
        y: 0,
        opacity: 1, 
        duration: 0.5,
        stagger: 0.2,
        ease: "power1.out",
    }
);

}

window.addEventListener('DOMContentLoaded', () => {
    toggleFilter()
    loadMore()
    handleMobileFilters()
})

